import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { PreTask } from "../../interfaces/Task";
import { Media } from "../../interfaces/Media";
import Uploader from "../../elements/Uploader";
import CustomEditor from "../../elements/CustomEditor";
import Help from "../../elements/HelpContent";
import { registerEventEnd, registerEventStart } from "../../../utils/utils";
import AITools from "../../elements/AITools";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

const emptyPreTask: any = {
    _id: '',
    name: '',
    type: 'warmup',
    instructions: '',
    media: [],
    text: '',
    updated: new Date()
}

export interface NewPreTaskWarmUpProps {
    saveForm: CallableFunction;
    closeForm: CallableFunction;
    task_language?: string;
}

export default function NewPreTaskWarmUp(props: NewPreTaskWarmUpProps) {
    const { t } = useTranslation();
    
    const [eventId, setEventId] = useState('');
    const [preTask, setPreTask] = useState<PreTask>(emptyPreTask);
    const [name, setName] = useState('');
    const [instructions, setInstructions] = useState('');
    const [text, setText] = useState('');
    const [media, setMedia] = useState<Media[]>([]);

    const handleMediaUpload = (media: Media[]) => {
        const newMedia = media.map((m: Media) => {
            return m;
        });
        setMedia(newMedia);
    }

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    }

    const handleInstructionsChange = (data: string) => {
        setInstructions(data);
    }

    const handleTextChange = (data: string) => {
        setText(data);
    }

    const handleClose = () => {
        registerEventEnd(eventId);
        props.closeForm();
    }

    const handleSave = () => {
        if (!name) {
            return;
        }
        registerEventEnd(eventId);
        preTask.name = name;
        preTask.instructions = instructions;
        preTask.media = media.map((m: Media) => { return m; });
        preTask.text = text;
        props.saveForm(preTask);
    }

    useEffect(() => {
        registerEventStart('new pretask warmup', '').then(data => { 
            setEventId(data);
        });

        return () => {
            registerEventEnd(eventId);
        };
    }, []);

    const doNothing = () => {
        
    }

    return(
        <Overlay title={t("New Pre-Task: Warm-up")} onClose={handleClose} actions={[
            {
                label: t("Cancel"),
                variant: 'secondary',
                onClick: handleClose
            },
            {
                label: t("Save"),
                variant: 'primary',
                onClick: handleSave
            }
        ]}>
            <div className="new-task-container warm-up">
                <div className="inner">
                    <h2>
                        { t("New Pre-Task: Warm-up") }
                        <Help id={ '652fdc701e5cf99991b571a9' } />
                    </h2>
                    <AITools />
                    <Form className="new-pre-task-form">
                        <div className="fields-container">
                            <Form.Group className="field field-title">
                                <Form.Label>{ t("Title of the Pre-Task") }</Form.Label>
                                <Form.Control type="text" name="name" required value={ name } onChange={ handleNameChange } />
                            </Form.Group>
                            <div className="field field-instructions">
                                <CustomEditor
                                    change={ handleInstructionsChange }
                                    changeFormatted={ doNothing }
                                    data={ '' }
                                    formatted= { '' }
                                    id="instructions"
                                    label={ t("Aim and instructions") }
                                    npl={ false }
                                    task_id={ '' }
                                    task_language={ props.task_language }
                                />
                            </div>
                            <Uploader media={ media } save={ handleMediaUpload } />
                            <div className="field field-text">
                                <CustomEditor
                                    change={ handleTextChange }
                                    changeFormatted={ doNothing }
                                    data={ '' }
                                    formatted= { '' }
                                    id="text"
                                    label={ t("Text")}
                                    npl={ false }
                                    task_id={ '' }
                                    task_language={ props.task_language }
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </Overlay>
    );
}